<template>
  <div class="container">
    <h1>{{ $t("videocall.title.videocall_end") }}</h1>
    <div>
      <img :src="logoUrl" alt="DivasPlay" />
    </div>
  </div>
</template>

<script>
import ThemeManager from "../modules/ThemeManager/ThemeManager.js";

export default {
  computed: {
    logoUrl() {
      let url = "/img";

      if (this.ThemeManager.isChadsTheme()) {
        url += "/themes/chads";
      }

      url += "/logo.png";

      return url;
    },
  },
}
</script>

<style scoped lang="scss">
@import "../styles/variables.scss";

.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

h1 {
  color: var(--pallete_clear_text_color);
  font-size: 2rem;
  text-align: center;
  margin-top: 2rem;

  @media (max-width: 480px) {
    font-size: 1.8rem;
  }
}
img {
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  display: block;
}
</style>
